import { apiClient } from '../../../helpers/api_helper';

export const getAllStoreOpsRoleData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetAllStoreOpsRoleList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllStoreOpsRoleForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetStoreOpsRoleSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getStoreOpsRolesById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/store/GetStoreOpsRolesById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createStoreOpsRole = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/store/InsertStoreOpsRole', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateStoreOpsRole = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Store/UpdateStoreOpsRole', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteStoreOpsRole = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Store/DeleteStoreOpsRole?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};